import React, { useEffect, useState } from 'react';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import { connect } from 'react-redux';
// import ErrorOutlineOutlined from '../../../../../static/assets/svg/mui-icons/ErrorOutlineOutlined.svg';
import {
  getReturnDetails,
  createRefund,
  createReturn,
} from '../../../../actionCreators/returnExchange';
import { createItemReturnData } from '../../../../CommonComponents/OrderStatus/utils';
import { orderPayment, saveShippingAddress } from '../../../../actionCreators/checkout';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import getSetCookie from '../../../../cookie';
import CommonLoader from '../../../components/Common/Loader';

let returnId = null;
function ConfirmationRequest(props) {
  const [click, setClick] = useState(false);
  const [isNonZeroPayment, setNonZeroPayemnt] = useState();
  const [returnIdItem, setReturnId] = useState(null);
  const {
    finalStep,
    exchangeItemId,
    returnDetails,
    orderPlaced,
    showFinalSubmitBtn,
    loadingPlaceOrder,
    exchangeOrderId,
    cartData,
    orderPayment,
    currentReturnItem,
    createRefund,
    returnOrderId,
    returnItemId,
    history,
    userAddress,
    createReturn,
    dataLocale,
    createReturnLoading,
  } = props;
  const {
    REFUND,
    EXCHANGE,
    VISIT_NEARBY_STORE,
    CONFIRM_RETURN_REQUEST,
    REFUND_STORECREDIT_PICKUP,
    PLACE_ORDER,
    CONFIRM_AND_SCHEDULE_STORE_VISIT,
    EXCHANGE_REFUND_DEATAILS,
    PICKUP_EXCHANGE_DETAILS,
    PICKUP_REFUND_DETAILS,
    ONCE_YOU_VISIT_LENSKART_STORE_WE_WILL_INSPECT,
    EXCHANGE_PICKUP,
    REFUND_PICKUP,
  } = dataLocale;
  useEffect(() => {
    if ((returnIdItem || returnDetails) && click) {
      if (finalStep === EXCHANGE && !isNonZeroPayment) {
        const data = {
          device: 'desktop',
          paymentInfo: { paymentMethod: 'exchangep' },
        };
        if (!orderPlaced && !loadingPlaceOrder) {
          orderPayment(data, true);
        }
      }
      if (
        returnDetails &&
        !returnDetails.error &&
        (finalStep === VISIT_NEARBY_STORE || finalStep === REFUND)
      ) {
        history.push({
          pathname: `/customer/my/order/return/confirm-details/${returnOrderId}/${returnItemId}`,
          state: { orderId: returnOrderId, itemId: returnItemId },
        });
      }
    }
  }, [returnDetails, click]);

  useEffect(() => {
    if (returnDetails || returnIdItem) {
      if (finalStep === EXCHANGE && orderPlaced) {
        history.push({
          pathname: `/customer/my/order/return/confirm-details/${returnOrderId}/${returnItemId}`,
          state: { orderId: returnOrderId, itemId: returnItemId },
        });
      }
    }
  }, [orderPlaced]);

  useEffect(() => {
    if (currentReturnItem && currentReturnItem.item) {
      const { itemTracking, returnId: itemReturnId } = currentReturnItem.item;
      returnId = itemReturnId && itemTracking?.status !== 'RETURN_CANCELLED' ? itemReturnId : null;
      if (returnId && returnId !== returnIdItem) setReturnId(returnId);
    }
  }, [currentReturnItem, returnDetails]);

  useEffect(() => {
    if (cartData?.totals?.total > 0) setNonZeroPayemnt(cartData.totals?.total);
  }, [cartData]);

  const onCTAClickFunctionality = isReturnCallHit => {
    setClick(true);
    const refundMethod = sessionStorageHelper.getItem('refundMethod') || {};
    if (finalStep === EXCHANGE) {
      if (currentReturnItem?.item) {
        sessionStorageHelper.setItem('returnedItemDetails', {
          orderId: exchangeOrderId,
          itemId: currentReturnItem.item.id,
          itemPowerRequired: currentReturnItem.item.powerRequired,
          prescriptionView: currentReturnItem.item.prescriptionView,
        });
      }
      if (isNonZeroPayment) {
        if (returnId) {
          sessionStorageHelper.setItem('returnedItemId', returnId);
        } else {
          sessionStorageHelper.removeItem('returnedItemId');
        }
        history.push({
          pathname: `/customer/my/order/return/payment-details/${exchangeOrderId}/${exchangeItemId}`,
          state: { orderId: exchangeOrderId, itemId: exchangeItemId },
        });
      } else if (!returnId) {
        if (!isReturnCallHit) {
          const returnData = createItemReturnData(userAddress);
          createReturn(returnOrderId, returnData);
        }
      } else if (returnId) {
        const data = {
          device: 'desktop',
          paymentInfo: { paymentMethod: 'exchangep' },
        };
        orderPayment(data, true);
      }
    } else if ((!returnId && refundMethod) || finalStep === VISIT_NEARBY_STORE) {
      if (!isReturnCallHit) {
        const returnData = createItemReturnData(userAddress);
        createReturn(returnOrderId, returnData);
      }
    } else if (returnId && refundMethod) {
      if (refundMethod === 'cashfree') {
        getSetCookie.setCookie('refundOrderId', exchangeOrderId);
        getSetCookie.setCookie('refundItemId', exchangeItemId);
      }
      createRefund({ orderId: exchangeOrderId, itemId: exchangeItemId, refundMethod });
    }
  };
  const onCTAClick = () => {
    // ExchangeOnly case
    const isExchangeOnly = sessionStorageHelper.getItem('isExchangeOnlyCase');
    if (!isExchangeOnly && !isNonZeroPayment && !returnId) {
      const returnData = createItemReturnData(userAddress);
      createReturn(returnOrderId, returnData);
      onCTAClickFunctionality(true);
    } else {
      onCTAClickFunctionality();
    }
  };

  const confirmationTitle = () => {
    let title = '';
    if (finalStep === VISIT_NEARBY_STORE) title = EXCHANGE_REFUND_DEATAILS;
    if (finalStep === EXCHANGE) title = PICKUP_EXCHANGE_DETAILS;
    if (finalStep === REFUND) title = PICKUP_REFUND_DETAILS;
    return title;
  };

  const confirmationSubTitle = () => {
    const refundMethod = sessionStorageHelper.getItem('refundMethod') || {};
    let subtitle = '';
    if (finalStep === VISIT_NEARBY_STORE) subtitle = ONCE_YOU_VISIT_LENSKART_STORE_WE_WILL_INSPECT;
    if (finalStep === EXCHANGE) subtitle = EXCHANGE_PICKUP;
    if (finalStep === REFUND) {
      if (refundMethod === 'storecredit') subtitle = REFUND_STORECREDIT_PICKUP;
      else subtitle = REFUND_PICKUP;
    }
    return subtitle;
  };

  const buttonText = () => {
    let text = '';
    if (finalStep === VISIT_NEARBY_STORE) text = CONFIRM_AND_SCHEDULE_STORE_VISIT;
    if (finalStep === EXCHANGE) {
      text = isNonZeroPayment ? 'Payment Summary' : PLACE_ORDER;
    }
    if (finalStep === REFUND) text = CONFIRM_RETURN_REQUEST;
    return text;
  };
  return (
    <div>
      <div className="display-flex bora-4 bg-cyan margin-10" style={{ padding: '8px 16px' }}>
        <img
          alt="error-outline"
          className="margin-r12"
          src="https://static.lenskart.com/media/desktop/img/myorder/ErrorOutlineOutlined.svg"
        />
        <div>
          <p
            className="fs16"
            style={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '150%',
            }}
          >
            {confirmationTitle()}
          </p>
          <p
            className="fs14"
            style={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 'normal',
              lineHeight: '143%',
              letterSpacing: '.15px',
            }}
          >
            {confirmationSubTitle()}
          </p>
        </div>
      </div>
      {createReturnLoading || loadingPlaceOrder ? (
        <CommonLoader />
      ) : (
        showFinalSubmitBtn && (
          <Button
            className="float-right margin-t15 margin-r15 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase roboto"
            onClick={onCTAClick}
          >
            {buttonText()}
          </Button>
        )
      )}
    </div>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    cartData,
    itemReturnDetails: state.returnExchange.itemReturnDetails,
    returnDetails: state.returnExchange.returnDetails,
    refundDetails: state.returnExchange.refundDetails,
    exchangeShippingAddress: state.checkout.saveShippingAddress,
    orderPlaced: state.checkout.orderPlaced,
    loadingPlaceOrder: state.checkout.loadingPlaceOrder,
    exchangeOrderId: state.returnExchange.exchangeOrderId,
    currentReturnItem: state.returnExchange.currentReturnItem,
    exchangeItemId: state.returnExchange.exchangeItemId,
    createReturnLoading: state.returnExchange.createReturnLoading,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getReturnDetails: (orderId, itemId) => dispatch(getReturnDetails(orderId, itemId)),
    createReturn: (orderId, data) => dispatch(createReturn(orderId, data)),
    orderPayment: (data, isExchange) => dispatch(orderPayment(data, isExchange)),
    createRefund: data => dispatch(createRefund(data)),
    saveShippingAddress: (data, isExchange) => dispatch(saveShippingAddress(data, isExchange)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationRequest);
